import {
  BigText,
  CardSubtitle,
  CardTitle,
  Content,
  Stack,
  Text,
  CenteredPanel,
  Frame,
  Container,
} from '@kinesis/bungle';
import {
  HeaderContainer,
  UnitContainer,
  ValueContainer,
} from './evaluation-card.styles';
import { Unit } from '@/types';
import { render, renderUnit, renderValue } from '@/data/units';

const EvaluationCard = (props: EvaluationCardProps) => {
  const {
    title,
    background,
    value,
    unit,
    description,
    inlineUnit = false,
    inlineUnitDescription,
  } = props;
  return (
    <Content
      padding='medium'
      border
      borderRadiusSize='small'
      background='white'
      paddingMode='equal'
    >
      <Stack space='medium'>
        <HeaderContainer>
          <CardTitle>{title}</CardTitle>
        </HeaderContainer>
        <Content
          minHeight={'160px'}
          background={background}
          padding={'medium'}
          paddingMode={'equal'}
          border
          borderRadiusSize={'small'}
          sizing='fill-container'
          alignX='stretch'
        >
          <Container>
            <Frame>
              <CenteredPanel centerY>
                <ValueContainer>
                  <BigText>
                    {inlineUnit
                      ? render(value, unit)
                      : renderValue(value, unit)}
                  </BigText>
                </ValueContainer>
                {!inlineUnit && (
                  <UnitContainer>
                    <Text tone='secondary'>{renderUnit(unit)}</Text>
                  </UnitContainer>
                )}
                {inlineUnitDescription && (
                  <UnitContainer>
                    <Text tone='secondary'>{inlineUnitDescription}</Text>
                  </UnitContainer>
                )}
              </CenteredPanel>
            </Frame>
          </Container>
        </Content>
        <CardSubtitle>{description}</CardSubtitle>
      </Stack>
    </Content>
  );
};

export type EvaluationCardProps = {
  title: string;
  inlineUnit?: boolean;
  inlineUnitDescription?: string;
  description: string;
  value: number;
  unit: Unit;
  background:
    | 'black'
    | 'blue'
    | 'gray'
    | 'green'
    | 'red'
    | 'transparent'
    | 'white'
    | 'yellow';
};

export { EvaluationCard };
